/** True for any community page URL (org, group or preview), ignoring the query string. */
export function isCommunityUrl(url: string | null | undefined): boolean {
  return (url || '').split('?')[0].split('/').includes('community');
}
